const timeouts: { [id: string]: any } = {};

/**
 * Debounce function call
 * @param {Function} fn
 * @param {number} wait in ms
 * @param {string} id
 * @returns {(function(): exports<*>)|*}
 */
export const debounce = (fn: (..._: any) => void, wait: number, id?: string) => {
    id ??= crypto.randomUUID();

    return (...args: any) => {
        const later = async () => {
            delete timeouts[id];
            return fn.apply(null, args);
        };

        clearTimeout(timeouts[id]);
        timeouts[id] = setTimeout(later, wait);
    };
};
